module.exports = __webpack_public_path__ + "img/es.46179d5a.svg";